




import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
    components: {},
})
export default class UposLogoFull extends Vue {
    public get logoSrc(): string {
        const dir = this.$alt.config.common.logoDirectory;
        return require(`@/assets/images/${dir}/logo_full.png`);
    }
}
